// Filtros de negocio do relatorio (etiqueta, origem, produto e condicoes de atributo do cartao). Mesmos nomes de
// parametro e mesma serializacao do quadro do funil (taskFilters.js, spec 005): o que a tela do relatorio aplica e
// o que o funil aplicaria, e os nomes da URL sao os da API.
import {
  createFilterState,
  stateFromQuery,
  stateToApiParams,
} from 'kanban/helper/taskFilters';

const pick = ({ label, source, productId, attributeFilters }) => ({
  label,
  source,
  productId,
  attributeFilters,
});

export const createReportFilters = () => pick(createFilterState());

// Parametros da API e da URL: so o que esta aplicado ('all' e lista vazia ficam de fora); attribute_filters em JSON.
export const buildReportParams = filters =>
  stateToApiParams(createFilterState(pick(filters)));

// Le da URL; JSON invalido vira lista vazia. Com as definicoes de atributo de cartao, descarta condicoes que nao
// valem mais (atributo apagado, operador ou valor fora da regra) e conta quantas caiu.
export const filtersFromRouteQuery = (query, definitions = null) => {
  const { state, dropped } = stateFromQuery(
    {
      label: query.label,
      source: query.source,
      product_id: query.product_id,
      attribute_filters: query.attribute_filters,
    },
    definitions
  );
  return { filters: pick(state), dropped };
};
